const SingleChoiceQue = ({ queTitle, answers }) => {
  return (
    <div className="flex flex-col">
      <h4 className="text-lg font-semibold text-black mb-4">{queTitle}</h4>

      <ul className="flex flex-col gap-3">
        {answers.map((item, index) => (
          <li
            key={item.id}
            className="flex items-center gap-3 p-3 rounded-xl border border-slate-200"
          >
            <input type="radio" disabled className="h-4 w-4 accent-mpPurple" />
            <span className="text-slate-700 font-medium">{item.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SingleChoiceQue;
